import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/components/bases/base-component';
import { ConfirmDeleteModalComponent } from '../../../../core/components/delete-modal/confirm-delete-modal-component';
import { IsInvalidDirective } from '../../../../core/directives/is-invalid.directive';
export class AreasEntryComponent extends BaseComponent {
    constructor(plantingSiteService, canDeactivateService, route, router, userService) {
        super();
        this.plantingSiteService = plantingSiteService;
        this.canDeactivateService = canDeactivateService;
        this.route = route;
        this.router = router;
        this.userService = userService;
        this.selectedSiteArea = {};
        this.formData = new FormData();
        this.validFileMimeTypes = ['image/jpeg', 'image/png'];
        this.showEditValidation = false;
    }
    ngOnInit() {
        this.getCurrentUser();
        this.route.paramMap.subscribe(params => {
            let areaId = params.get('tabId');
            if (areaId != 'new') {
                this.selectedSiteArea = this.siteAreas.find(c => c.id == areaId);
                const valueSiteArea = this.selectedSiteArea;
                this.onCheckUrl(valueSiteArea);
            }
        });
        // this.wizardModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.files = undefined);
        // this.editModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.editPhoto = undefined);
        this.setupYears();
    }
    setupYears() {
        let firstYear = 2010;
        let yearToday = new Date().getFullYear();
        this.years = new Array(yearToday - firstYear + 2)
            .fill(0)
            .map((value, index) => index + firstYear).reverse();
    }
    filesSelected(fileList) {
        let files = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if (this.validFileMimeTypes.includes(file.type))
                files.push(file);
        }
        if (files.length == 0)
            return;
        this.files = files;
        // this.wizardModal.show();
    }
    closeWizard() {
        this.fileInput.nativeElement.value = '';
        // this.wizardModal.hide();
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isInvalidDirectives.some(value => value.isInvalid))
                return;
            if (this.selectedSiteArea.code === undefined)
                this.formData.append('code', '');
            if (this.selectedSiteArea.description === undefined)
                this.formData.append('description', '');
            if (this.selectedSiteArea.id) {
                this.formData.append('year', this.selectedSiteArea.year.toString());
                this.formData.append('id', this.selectedSiteArea.id);
                this.formData.append('name', this.selectedSiteArea.name);
                this.formData.append('code', this.selectedSiteArea.code);
                this.formData.append('description', this.selectedSiteArea.description);
                let result = yield this.plantingSiteService.updatePlantingSiteArea(this.formData);
                this.selectedSiteArea.kmlUrl = this.isKmlFileDelete ? undefined : result.kmlUrl;
                this.selectedSiteArea.flightPathUrl = this.isFlightPathFileDelte ? undefined : result.flightPathUrl;
                this.selectedSiteArea.kmlAreaProperties = this.isKmlFileDelete ? null : result.kmlAreaProperties;
            }
            else {
                this.formData.append('plantingSiteId', this.plantingSiteId);
                this.formData.append('name', this.selectedSiteArea.name);
                this.formData.append('code', this.selectedSiteArea.code);
                this.formData.append('description', this.selectedSiteArea.description);
                this.formData.append('year', this.selectedSiteArea.year.toString());
                let result = yield this.plantingSiteService.addPlantingSiteArea(this.formData);
                this.selectedSiteArea.id = result.id;
                this.selectedSiteArea.code = result.code;
                this.selectedSiteArea.kmlUrl = this.isKmlFileDelete ? undefined : result.kmlUrl;
                this.selectedSiteArea.flightPathUrl = this.isFlightPathFileDelte ? undefined : result.flightPathUrl;
                this.selectedSiteArea.kmlAreaProperties = this.isKmlFileDelete ? null : result.kmlAreaProperties;
                this.selectedSiteArea.videos = [];
                this.selectedSiteArea.collections = [];
                this.selectedSiteArea.species = [];
                this.siteAreas.push(this.selectedSiteArea);
            }
            if (this.newAreaPhoto) {
                var result = yield this.plantingSiteService.updatePlantingSiteAreaPhoto(this.newAreaPhoto, this.selectedSiteArea.id);
                this.selectedSiteArea.photo = result.data;
            }
            this.router.navigate(['/admin', 'plantingSites', this.plantingSiteId, 'plantings'], { replaceUrl: true });
        });
    }
    onFileKMLUpload(event) {
        if (event.target.files && event.target.files.length) {
            this.kmlFileName = event.target.files[0].name;
            const [fileKML] = event.target.files;
            this.isKMLUpload = true;
            this.validKML = true;
            this.isKmlFileDelete = false;
            if (this.formData.get('kmlFile') !== null || undefined) {
                this.formData.set('kmlFile', fileKML, this.kmlFileName);
                this.formData.set('isKmlDelete', `${this.isKmlFileDelete}`);
                this.selectedSiteArea.kmlUrl = this.kmlFileName;
            }
            else {
                this.formData.append('kmlFile', fileKML, this.kmlFileName);
            }
        }
    }
    onFileKMLDelete(event) {
        this.isKMLUpload = false;
        this.isKmlFileDelete = true;
        if (this.formData.get('isKmlDelete') !== null || undefined) {
            this.formData.set('isKmlDelete', `${this.isKmlFileDelete}`);
        }
        else {
            this.formData.append('isKmlDelete', `${this.isKmlFileDelete}`);
        }
    }
    onClickKML(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const nameData = data.split("/");
            const iframe = document.createElement('a');
            iframe.setAttribute('target', '_blank');
            iframe.setAttribute('href', `${data}`);
            iframe.setAttribute('download', `${nameData[2]}`);
            document.body.appendChild(iframe);
            iframe.click();
            iframe.remove();
        });
    }
    onFileFlightPathUpload(event) {
        if (event.target.files && event.target.files.length) {
            this.flightPathName = event.target.files[0].name;
            const [fileFlightPath] = event.target.files;
            this.isFlightPathUpload = true;
            this.validFlightPath = true;
            this.isFlightPathFileDelte = false;
            if (this.formData.get('flightPathFile') !== null || undefined) {
                this.formData.set('flightPathFile', fileFlightPath, this.flightPathName);
                this.formData.set('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
                this.selectedSiteArea.flightPathUrl = this.flightPathName;
            }
            else {
                this.formData.append('flightPathFile', fileFlightPath, this.flightPathName);
                this.formData.append('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
            }
        }
    }
    onFileFligthPathDelete(event) {
        this.isFlightPathUpload = false;
        this.isFlightPathFileDelte = true;
        if (this.formData.get('isFlightPathDelete') !== null || undefined) {
            this.formData.set('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
        }
        else {
            this.formData.append('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
        }
    }
    onClickFlightPath(data) {
        const nameData = data.split("/");
        const iframe = document.createElement('a');
        iframe.setAttribute('target', '_blank');
        iframe.setAttribute('href', `${data}`);
        iframe.setAttribute('download', `${nameData[2]}`);
        document.body.appendChild(iframe);
        iframe.click();
        iframe.remove();
    }
    onCheckUrl(valueSiteArea) {
        if (valueSiteArea.kmlUrl != null) {
            this.isKMLUpload = true;
            let fileKmlName = valueSiteArea.kmlUrl.split("/");
            this.kmlFileName = fileKmlName[fileKmlName.length - 1];
            this.uploadKML = true;
        }
        if (valueSiteArea.flightPathUrl != null) {
            this.isFlightPathUpload = true;
            let fileFlightPathName = valueSiteArea.flightPathUrl.split("/");
            this.flightPathName = fileFlightPathName[fileFlightPathName.length - 1];
            this.uploadFlightPath = true;
        }
    }
    onPhotoSelected(photo) {
        this.newAreaPhoto = photo;
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
}
